import { SVGProps } from 'react';

const IcInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.0005 2.69231C6.85999 2.69231 2.6928 6.8595 2.6928 12C2.6928 17.1404 6.85999 21.3077 12.0005 21.3077C17.1409 21.3077 21.3082 17.1404 21.3082 12C21.3082 6.8595 17.1409 2.69231 12.0005 2.69231ZM1.00049 12C1.00049 5.92486 5.92535 1 12.0005 1C18.0756 1 23.0005 5.92486 23.0005 12C23.0005 18.0752 18.0756 23 12.0005 23C5.92535 23 1.00049 18.0752 1.00049 12Z'
      fill='#2563EB'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.0103 10.5704C12.8346 10.5704 13.6645 11.1365 13.6645 11.8349V17.7356C13.6645 18.4339 12.8147 19 11.9904 19C11.1661 19 10.3237 18.4339 10.3237 17.7356V11.8349C10.3237 11.1365 11.186 10.5704 12.0103 10.5704ZM11.9904 6C10.8913 6 10.3236 6.75482 10.3236 7.68592C10.3236 8.61702 10.8913 9.37183 11.9904 9.37183H12.0103C13.1094 9.37183 13.6645 8.61702 13.6645 7.68592C13.6645 6.75482 13.1094 6 12.0103 6H11.9904Z'
      fill='#2563EB'
    />
  </svg>
);
export default IcInfo;
